import React from 'react'
import './category.css'

function Category({cat}) {
    return (
        <div className="category">
            {cat.name}                        
        </div>
    )
}

export default Category
